import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import {
    FormControlLabel,
    Radio,
    RadioGroup,
    TextField,
} from '@material-ui/core';
import { AGENCY_EMAIL_OPTIONS } from '../../utils';
import messages from './messagesAgencyEmail';

const AgencyEmail = ({
    onChange,
    intl: { formatMessage },
    error,
    helperText,
}) => {
    const [selectedOption, setSelectedOption] = useState(AGENCY_EMAIL_OPTIONS.NONE);
    const [email, setEmail] = useState('');

    const handleOptionChange = (e) => {
        const newOption = e.target.value;
        setSelectedOption(newOption);
        onChange({
            option: newOption,
            email: newOption === AGENCY_EMAIL_OPTIONS.OTHER ? email : null,
        });
    };

    const handleEmailChange = (e) => {
        const newEmail = e.target.value;
        setEmail(newEmail);
        if (selectedOption === AGENCY_EMAIL_OPTIONS.OTHER) {
            onChange({
                option: selectedOption,
                email: newEmail,
            });
        }
    };

    return (
        <div className="col-12">
            <h5>{formatMessage(messages.lblAgencyEmail)}</h5>
            <RadioGroup
                aria-label="agency-email-radio-options"
                name="agency-email-radio-options"
                value={selectedOption}
                onChange={handleOptionChange}
            >
                <FormControlLabel
                    key={AGENCY_EMAIL_OPTIONS.NONE}
                    value={AGENCY_EMAIL_OPTIONS.NONE}
                    control={<Radio />}
                    label={<div>{formatMessage(messages.lblNone)}</div>}
                />
                <FormControlLabel
                    key={AGENCY_EMAIL_OPTIONS.OTHER}
                    value={AGENCY_EMAIL_OPTIONS.OTHER}
                    control={<Radio />}
                    label={<div>{formatMessage(messages.lblOther)}</div>}
                />
            </RadioGroup>
            {selectedOption === AGENCY_EMAIL_OPTIONS.OTHER && (
                <TextField
                    id="srtAgencyEmail"
                    name="agencyEmail"
                    label={formatMessage(messages.lblAgencyEmail)}
                    fullWidth
                    value={email}
                    onChange={handleEmailChange}
                    disabled={false}
                    error={error}
                    helperText={helperText}
                />
            )}
        </div>
    );
};

AgencyEmail.propTypes = {
    onChange: PropTypes.func,
    intl: PropTypes.object,
    error: PropTypes.array,
    helperText: PropTypes.string,
};

export default injectIntl(AgencyEmail);
